<template>
  <div class="tab_container">
    <!-- 本月洞见/总结 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        本月洞见/总结
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('conclusion')"
          >保存</el-button
        >
      </div>
    </div>
    <conclusion ref="conclusion" />
    <!-- 基本信息 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        基本信息
      </div>
    </div>
    <base-info ref="baseInfo" />
    <!-- 宏观环境 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        宏观环境
      </div>
    </div>
    <!-- 政治环境 -->
    <div class="second_title">
      政治环境
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('politicalEnvironment')"
        >保存</el-button
      >
    </div>
    <political-environment ref="politicalEnvironment" />
    <!-- 经济环境 -->
    <div class="second_title">
      经济环境
    </div>
    <!-- 汇率变化趋势 -->
    <div class="third_title">
      汇率变化趋势
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('exchangeRateChangeTrend')"
        >保存</el-button
      >
    </div>
    <exchange-rate-change-trend ref="exchangeRateChangeTrend" />
    <!-- 外汇储备 (单位：万美元；进口覆盖天数=外汇储备总额/进口总额) -->
    <div class="third_title">
      外汇储备 (单位：万美元；进口覆盖天数=外汇储备总额/进口总额)
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('foreignExchangeReserve')"
        >保存</el-button
      >
    </div>
    <foreign-exchange-reserve ref="foreignExchangeReserve" />
    <!-- 贷款利率 -->
    <div class="third_title">
      贷款利率
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('loanRate')"
        >保存</el-button
      >
    </div>
    <loan-rate ref="loanRate" />
    <!-- 通货膨胀率 -->
    <div class="third_title">
      通货膨胀率
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('inflationRate')"
        >保存</el-button
      >
    </div>
    <inflation-rate ref="inflationRate" />
    <!-- 失业率 -->
    <div class="third_title">
      失业率
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('unemploymentRate')"
        >保存</el-button
      >
    </div>
    <unemployment-rate ref="unemploymentRate" />
    <!-- 市场实销及变化趋势 -->
    <div class="second_title">
      市场实销及变化趋势
    </div>
    <div class="third_title">
      市场实销
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('marketSaleChangeTrend')"
        >保存</el-button
      >
    </div>
    <market-sale-change-trend ref="marketSaleChangeTrend" />
    <!-- TOP5车型 市场实销趋势 -->
    <div class="second_title">
      TOP5车型 市场实销趋势
    </div>
    <div class="third_title">
      市场实销
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('top5MarketSaleChangeTrend')"
        >保存</el-button
      >
    </div>
    <top5-market-sale-change-trend ref="top5MarketSaleChangeTrend" />
    <!-- 各品牌标杆车型 市场实销趋势 -->
    <div class="second_title">
      各品牌标杆车型 市场实销趋势
    </div>
    <div class="third_title">
      市场实销
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('allBrandMarketSaleChangeTrend')"
        >保存</el-button
      >
    </div>
    <all-brand-market-sale-change-trend ref="allBrandMarketSaleChangeTrend" />
  </div>
</template>

<script>
import Conclusion from "./conclusion.vue";
import BaseInfo from "./baseInfo.vue";
import PoliticalEnvironment from "./politicalEnvironment.vue";
import ExchangeRateChangeTrend from "./exchangeRateChangeTrend.vue";
import ForeignExchangeReserve from "./foreignExchangeReserve.vue";
import LoanRate from "./loanRate.vue";
import InflationRate from "./inflationRate.vue";
import UnemploymentRate from "./unemploymentRate.vue";
import MarketSaleChangeTrend from "./marketSaleChangeTrend.vue";
import Top5MarketSaleChangeTrend from "./top5MarketSaleChangeTrend.vue";
import AllBrandMarketSaleChangeTrend from "./allBrandMarketSaleChangeTrend.vue";
import { getLookMarketApi } from "@/api/saleTaskCollection";

export default {
  components: {
    Conclusion,
    BaseInfo,
    PoliticalEnvironment,
    ExchangeRateChangeTrend,
    ForeignExchangeReserve,
    LoanRate,
    InflationRate,
    UnemploymentRate,
    MarketSaleChangeTrend,
    Top5MarketSaleChangeTrend,
    AllBrandMarketSaleChangeTrend
  },
  data() {
    return {};
  },
  methods: {
    async init(showDataObj) {
      await this.getLookMarket(showDataObj.queryParams);
    },
    // 获取看差距
    async getLookMarket(queryParams = {}) {
      try {
        let data = {};
        const res = await getLookMarketApi({
          ...queryParams
        });
        if (res.status == 0) {
          data = res.data || {};
        } else {
          this.$DonMessage.error(res.message);
        }
        this.$refs.conclusion.init(data.saleSummary, queryParams);
        this.$refs.baseInfo.init(data.saleInformation);
        this.$refs.politicalEnvironment.init(data.saleInformation);
        this.$refs.exchangeRateChangeTrend.init(data.rateChange, queryParams);
        this.$refs.foreignExchangeReserve.init(data.moneyDayReq, queryParams);
        this.$refs.loanRate.init(data.loanInterestRate, queryParams);
        this.$refs.inflationRate.init(data.inflationRate, queryParams);
        this.$refs.unemploymentRate.init(
          data.unemploymenRateEconomicChanges,
          queryParams
        );
        this.$refs.marketSaleChangeTrend.init(data.saleData, queryParams);
        this.$refs.top5MarketSaleChangeTrend.init(
          data.saleDataTop5,
          queryParams
        );
        this.$refs.allBrandMarketSaleChangeTrend.init(
          data.saleDataEach,
          queryParams
        );
        this.$emit(
          "updateTime",
          "lookMarketTabTime",
          this.getClosestDate([
            data.saleSummary?.updateTime,
            data.saleInformation.updateTime,
            data.rateChange.searchYearRate?.updateTime,
            data.moneyDayReq.searchYearMoney?.updateTime,
            data.loanInterestRate?.updateTime,
            data.inflationRate?.updateTime,
            data.unemploymenRateEconomicChanges.unemploymenRate?.updateTime,
            data.saleData.secondSearchData[0]?.updateTime,
            data.saleDataTop5.secondSearchData[0]?.updateTime,
            data.saleDataEach.secondSearchData[0]?.updateTime
          ])
        );
      } catch (error) {}
    },
    // 获取最近的日期
    getClosestDate(dates) {
      if (dates.length === 0) return null; // 如果没有日期，返回null
      dates.sort((a, b) => a - b); // 按时间顺序排序
      return dates[0] || ""; // 取第一个元素，即最早的日期
    },
    // 保存
    handleSave(refField) {
      this.$refs[refField].handleSave(() => {
        this.$emit("updateTime");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tab_container {
  padding-bottom: 20px;
  .hearder_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title_icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .third_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 10px 10px 10px 62px;
  }
  .second_title + .third_title {
    padding-top: 25px;
  }
  .title_btn {
    margin-left: 20px;
  }
}
</style>
